import moment from 'moment';

const state = {
  stats: [],
  selectedStats: null,
  // selVid:null,
  selectedVideos: [],
  startDate: moment().format("YYYY-MM-DD"),
  endDate: moment().format("YYYY-MM-DD"),
  todaysStats: []
}

const mutations = {
  RESET_STATS: function (state) {
    state.stats = [];
    state.selectedStats = null;
    state.selectedVideos = [];
    state.startDate = "";
    state.endDate = "";
  },
  SET_STATS: function (state, stats) {
    state.stats = stats;
  },
  ADD_STATS: function (state, stats) {
    state.stats.push(stats);
  },
  SET_SELECTED_STATS: function (state, statsId) {
    state.selectedStats = statsId;
  },
  SET_STARTDATE: function (state, date) {
    state.startDate = date;
  },
  SET_ENDDATE: function (state, date) {
    state.endDate = date;
  },
  SET_SELECTED_VIDEO(state, videos) {
    state.selectedVideos = videos;
  },
  // SET_SELECTED_VIDEO(state, videos) {
  //   state.selVid = videos;
  // },
  CLEAR_STATS: function (state, date) {
    state.stats = []
  },
  ADD_TODAYS_STATS: function (state, stats) {
    state.todaysStats.push(stats)
  },
}

const actions = {
  changeSelectedStats({ dispatch, commit, state }, statsId) {
    commit('SET_SELECTED_STATS', statsId)
  },
  changeSelectedVideo({ dispatch, commit, state }, videoId) {
    commit('SET_SELECTED_VIDEO', videoId)
  },
  changeStartDate({ dispatch, commit, state }, date) {
    /* console.log(date) */
    commit('SET_STARTDATE', date)
  },
  changeEndDate({ dispatch, commit, state, rootState }, date) {
    commit('SET_ENDDATE', date)
  },
  downloadStats({ dispatch, commit, state, rootState }) {

    commit('CLEAR_STATS')

    dispatch('setMessage', "Downloading statistics...");

    let d = []
    var a = moment(state.startDate);

    var b = moment(state.endDate);

    new Promise((resolve, reject) => {
      for (var m = moment(a); m.diff(b, 'days') <= 0; m.add(1, 'days')) {
        rootState.Database.db
          .collection("statistics")
          .doc(state.selectedStats)
          .collection("videos")
          .doc(m.format('YYYY-MM-DD'))
          .get()
          .then(function (doc) {
            if (doc.exists) {
              /* console.log('STATS =>', doc.data()); */
              /* d.push({
                date: m.format('YYYY-MM-DD'),
                data: doc.data()
              }) */
              let b = doc.data();
              b.date = doc.id;
              commit('ADD_STATS', b);
            }
          });
        setTimeout(() => {
          resolve(true)
        }, 3000)
      }
    }).then(() => {
      dispatch('clearMessage')
    });


  },
  downloadTodaysStats({ commit, state, rootState, getters }) {

    return new Promise(resolve => {
      let promiseArray = getters.getDevices.map(dev => {
        return rootState.Database.db
          .collection("statistics")
          .doc(dev.statsId)
          .collection("videos")
          .doc(moment().format('YYYY-MM-DD'))
          .get()
          .then(function (doc) {
            if (doc.exists) {
              commit('ADD_TODAYS_STATS', doc.data());
            }
          });
      })

      Promise.all(promiseArray).then(() => {
        resolve(true);
      })
    })

  }


}

const getters = {
  getStartDate(state) {
    return state.startDate
  },
  getEndDate(state) {
    return state.endDate
  },
  getStats(state) {
    if (state.stats != null) {
      return state.stats
    }
    else {
      return null
    }
  },
  getTodaysViews(state) {
    if (state.todaysStats.length > 0) {
      let t = 0;
      state.todaysStats.forEach(stat => {
        if(stat.views !== undefined){
          t += stat.views.length;
        }
      })
      return t;
    }
    else{
      return 0;
    }
  },
  getTodaysLikes(state) {
    if (state.todaysStats.length > 0) {
      let t = 0;
      state.todaysStats.forEach(stat => {
        if(stat.likes !== undefined){
          t += stat.likes.length;
        }
      })
      return t;
    }
    else{
      return 0;
    }
  },
  getTodaysDislikes(state) {
    if (state.todaysStats.length > 0) {
      let t = 0;
      state.todaysStats.forEach(stat => {
        if(stat.dislikes !== undefined){
          t += stat.dislikes.length;
        }
      })
      return t;
    }
    else{
      return 0;
    }
  },
  // getStatsPeriod(state){
  //   let dog;
  //   if(state.totalSums !== undefined && state.totalSums !== null){
  //     dog = {
  //       dates: [],
  //       views: [],
  //       dislikes: [],
  //       likes: [],
  //     };
  //     // Object to an array
  //     Object.keys(state.totalSums).map(function(key) {
  //       let b = moment(key, "YYYY-MM-DD");
  //       let now = moment();
  //       if (now.diff(b, "days") <= 15 && now.diff(b, "days") >= 0) {
  //         dog.dates.push(key);
  //         dog.views.push(state.totalSums[key].views);
  //         dog.likes.push(state.totalSums[key].likes);
  //         dog.dislikes.push(state.totalSums[key].dislikes);
  //       }
        
  //     });

  //     return dog;
  //   }
  // },





  getSelectedStats(state) {
    if (state.selectedStats !== null) {
      return state.selectedStats
    }
    else {
      return null
    }
  },
  getTotalViews(state) {
    if (state.stats.length > 0) {
      let l = 0;
      state.stats.forEach(element => {
        if (element.views !== undefined) {

          l += element.views.filter((item) => {
            return state.selectedVideos.findIndex((video) => { return video == item.videoId }) > -1
            /* return item.videoId == state.selectedVideos; */
          }).length

          // console.log(state.selectedVideos)

          // l += element.views.filter((item) => {
          //   return state.selectedVideos.findIndex((video) => { return video == item.videoId }) > -1
          //   /* return item.videoId == state.selectedVideos; */
          // }).length
        }
      });
      return l
    }
    else {
      return 0;
    }
  },
  getAverageViews(state) {
    if (state.stats.length > 0) {
      let l = [];
      state.stats.forEach(element => {
        if (element.views !== undefined) {
          l.push(element.views.filter((item) => {
            return state.selectedVideos.findIndex((video) => { return video == item.videoId }) > -1
            /* return item.videoId == state.selectedVideos; */
          }).length)
        }
      });
      if (l.length > 0) {
        let f = 0;
        l.forEach(element => {
          f += element;
        });
        return (f / l.length).toFixed(2);
      }
    }
    else {
      return 0;
    }
  },
  getTotalLikes(state) {
    if (state.stats.length > 0) {
      let l = 0;
      state.stats.forEach(element => {
        if (element.likes !== undefined) {

          l += element.likes.filter((item) => {
            return state.selectedVideos.findIndex((video) => { return video == item.videoId }) > -1
            /* return item.videoId == state.selectedVideos; */
          }).length
        }
      });
      return l
    }
    else {
      return 0;
    }
  },
  getAverageLikes(state) {
    if (state.stats.length > 0) {
      let l = [];
      state.stats.forEach(element => {
        if (element.likes !== undefined) {
          l.push(element.likes.filter((item) => {
            return state.selectedVideos.findIndex((video) => { return video == item.videoId }) > -1
            /*  return item.videoId == state.selectedVideos; */
          }).length)
        }
      });
      if (l.length > 0) {
        let f = 0;
        l.forEach(element => {
          f += element;
        });
        return (f / l.length).toFixed(2);
      }
    }
    else {
      return 0;
    }
  },
  getDateRangeArray(state) {
    let a = moment(state.startDate);
    let b = moment(state.endDate);
    let c = [];
    for (var m = moment(a); m.diff(b, 'days') <= 0; m.add(1, 'days')) {
      c.push(m.format('YYYY-MM-DD'))
    }
    return c;
  },
  getViewsFromSelectedVideos(state) {
    if (state.stats.length > 0 && state.selectedVideos.length > 0) {
      let temp = [];
      state.stats.forEach(day => {
        let a = day.views.filter(el => {
          return state.selectedVideos.findIndex(v => {
            return v === el.videoId
          }) > -1
        })
        a.date = day.date
        temp.push(a);
      })
      return temp;
    }
  },
  getLikesFromSelectedVideos(state) {
    if (state.stats.length > 0 && state.selectedVideos.length > 0) {
      let temp = [];
      state.stats.forEach(day => {
        let a = day.likes.filter(el => {
          return state.selectedVideos.findIndex(v => {
            return v === el.videoId
          }) > -1
        })
        a.date = day.date
        temp.push(a);
      })
      return temp;
    }
  },
  getDislikesFromSelectedVideos(state) {
    if (state.stats.length > 0 && state.selectedVideos.length > 0) {
      let temp = [];
      state.stats.forEach(day => {
        let a = day.dislikes.filter(el => {
          return state.selectedVideos.findIndex(v => {
            return v === el.videoId
          }) > -1
        })
        a.date = day.date
        temp.push(a);
      })
      return temp;
    }
  },
  getLikesPerDay(state) {
    if (state.stats.length > 0) {
      let l = [];
      state.stats.forEach(element => {
        if (element.likes !== undefined) {
          l.push(element.likes.filter((item) => {
            return state.selectedVideos.findIndex((video) => { return video == item.videoId }) > -1
            /* return item.videoId == state.selectedVideos; */
          }).length)
        }
      });
      return l;
    }
  },
  getDislikesPerDay(state) {
    if (state.stats.length > 0) {
      let l = [];
      state.stats.forEach(element => {
        if (element.dislikes !== undefined) {
          l.push(element.dislikes.filter((item) => {
            return state.selectedVideos.findIndex((video) => { return video == item.videoId }) > -1
            /* return item.videoId == state.selectedVideos; */
          }).length)
        }
      });
      return l;
    }
  },
  getMostViewedVideo(state) {
    if (state.stats.length > 0) {
      let l = [];
      state.stats.forEach(element => {
        if (element.views !== undefined) {
          element.views.forEach(el => {
            l.push(el);
          })
        }
      });
      if (l.length > 0) {
        return l.sort((a, b) =>
          l.filter(v => v.videoId === a.videoId).length
          - l.filter(v => v.videoId === b.videoId).length
        ).pop().videoId;
      }
      else {
        return "";
      }

    }
    else {
      return "";
    }
  },
  getMostLikedVideo(state) {
    if (state.stats.length > 0) {
      let l = [];
      state.stats.forEach(element => {
        if (element.likes !== undefined) {
          element.likes.forEach(el => {
            l.push(el);
          })
        }
      });
      if (l.length > 0) {
        return l.sort((a, b) =>
          l.filter(v => v.videoId === a.videoId).length
          - l.filter(v => v.videoId === b.videoId).length
        ).pop().videoId;
      }
      else {
        return "";
      }
    }
    else {
      return "";
    }
  },
  getViewsByCategory(state, getters) {

    if (state.stats.length > 0) {
      let categoryViews = [];

      let temp = [];

      state.stats.forEach(day => {

        day.views.forEach(view => {
          let ex = temp.findIndex((y) => { return y.videoId == view.videoId });
          if (ex == -1) {
            temp.push({
              videoId: view.videoId,
              views: 1
            })
          }
          else {
            temp[ex].views += 1;
          }
        })

      })

      temp.forEach(view => {
        let cats = getters.getCategories.filter((cat) => {
          return cat.videos.findIndex(vid => { return vid === view.videoId }) > -1
        });
        cats.forEach(cat => {
          let ex = categoryViews.findIndex((y) => { return y.id == cat.id });
          if (ex == -1) {
            categoryViews.push({
              id: cat.id,
              views: view.views
            })
          }
          else {
            categoryViews[ex].views += view.views;
          }
        })

      })
      return categoryViews;
    }
    else {
      return null;
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
} 



// WEBPACK FOOTER //
// ./src/store/modules/Stats.js